import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthOperatorService } from 'src/app/services/auth-operator.service';

@Component({
  selector: 'app-operator-login',
  templateUrl: './operator-login.component.html',
  styleUrls: ['./operator-login.component.scss']
})
export class OperatorLoginComponent implements OnInit {
  public loginForm: UntypedFormGroup;
  public _loading: boolean = false;
  public _error: boolean = false;

  constructor(
    public fb: UntypedFormBuilder,
    private auth: AuthOperatorService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: [undefined, [Validators.required, Validators.email]],
      passwd: [undefined, [Validators.required]]
    });
  }

  public makeLogin() {
    this._loading = true
    this.auth.login(
      this.loginForm.value.email,
      this.loginForm.value.passwd
    )
      .toPromise()
      .then((value) => {
        this.auth.logUserIn(value);
        this._loading = false
        this.router.navigate(['/operador'])
      })
      .catch(() => {
        this._loading = false
        this._error = true
        this.loginForm.controls['email'].setErrors({'incorrect': true});
        this.loginForm.controls['passwd'].setErrors({'incorrect': true});
      });
  }

}
